export * from './settings-actions'



/** WEBPACK FOOTER **
 ** ./src/actions/settings/index.js
 **/